<template>
  <div :class="wrapperClasses">
    <div class="listing">
      <b-button @click="addCollege" class="float-right" icon-left="plus" rounded>Add new college</b-button>
      <b-table :data="items" :row-class="(row, index) => assignRowClasses(row, index)">
        <template slot-scope="props">
          <b-table-column field="fullName" label="Full name" sortable>
            {{props.row.fullName}}
          </b-table-column>
          <b-table-column field="sortName" class="sort-name" label="Sort name" sortable>
            {{props.row.sortName}}
          </b-table-column>
          <b-table-column field="active" label="Active">
            <b-icon :icon="props.row.active|activeIcon" size="is-small "/>
          </b-table-column>
          <b-table-column field="_id" label="Edit">
            <span class="edit" v-on:click="showCollege(props.row._id)"><b-icon icon="square-edit-outline" /></span>
          </b-table-column>
        </template>
      </b-table>
      <b-button @click="addCollege" class="float-right" icon-left="plus" rounded>Add new college</b-button>
    </div>
    <CollegeDetail v-if="showDetail" :college="college" />
  </div>
</template>

<script>
import { listColleges } from '../api/methods';
import filters from "../mixins/filters";
import CollegeDetail from "./CollegeDetail";

export default {
  name: 'CollegeList',
  components: {
    CollegeDetail
  },
  mixins: [filters],
  data() {
    return {
      items: [],
      num: 0,
      perPage: 1000,
      start: 0,
      showDetail: false,
      college: {
        fullName: '',
        sortName: '',
        active: false
      },
      currId: ''
    }
  },
  computed: {
    wrapperClasses() {
      let cls = ["colleges"];
      if (this.showDetail) {
        cls.push("show-detail");
      }
      return cls;
    },
    total() {
      return this.items.length;
    },
  },
  created() {
    this.mapColleges()
  },
  mounted() {
    if (this.$route.path) {
      const parts = this.$route.path.substring(1).split('/');
      if (parts.length > 1) {
        this.currId = parts.pop();
      }
    }
  },
  filters: {
    activeIcon(val) {
      return val === true? 'check' : 'circle-off-outline';
    }
  },
  methods: {
    mapColleges() {
      listColleges(this.start, this.perPage).then(data => {
        if (data instanceof Array) {
          this.items = data.sort((a, b) => a.sortName > b.sortName? 1 : -1);
          if (this.currId.length > 5) {
            this.showCollege(this.currId);
          }
        }
      });
    },
    showCollege(id) {
      let college = null;
      if (id === 'new') {
        college = {
          _id: 'new',
          fullName: '',
          sortName: '',
          active: false
        }
      } else {
        college = this.items.find(c => c._id === id);
      }
      if (college instanceof Object) {
        const keys = Object.keys(college);
        if (keys.indexOf('fullName') >= 0) {
          this.college = college;
          this.currId = id;
          const newPath = '/colleges/' + id;
          if (this.$route.path !== newPath) {
            this.$router.push(newPath);
          }
          this.showDetail = true;
        }
      }
    },
    addCollege() {
      this.showCollege('new');
    },
    close() {
      this.showDetail = false;
      const nr = "/colleges";
      if (this.$route.path !== nr) {
        this.$router.push(nr);
      }
    },
    assignRowClasses(row, index) {
      let cls = [];
      if (index % 2 === 0) {
        cls.push("even");
      }
      if (row.active) {
        cls.push("active");
      }
      return cls.join(" ");
    },
    update() {
      this.mapColleges();
      this.close();
    }
  },
}
</script>